class MarqueeBar extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initMarquee();
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '1px 0px 0px 0px'}).observe(this);
  }

  initMarquee() {
    Marquee3k.init();

    this.bindEditorEvents();
  }

  bindEditorEvents() {
      document.addEventListener('shopify:section:deselect', (event) => {
        Marquee3k.refreshAll();
      });
    }
}

customElements.define('marquee-announcement', MarqueeBar);